import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { simulationEngine } from './simulation/SimulationEngine';
import { startSupabaseBridge } from './datasource/supabaseBridge';
import './index.css';

// ── Choix de la source de données ──────────────────────────────────────────
//   VITE_DATA_SOURCE = 'live'  → lecture temps réel depuis Supabase
//   VITE_DATA_SOURCE = 'mock'  → simulation locale (défaut)
const MODE = (import.meta.env.VITE_DATA_SOURCE as string) ?? 'mock';

if (MODE === 'live') {
  startSupabaseBridge().then(ok => {
    // Si Supabase n'est pas configuré, on retombe sur la simulation
    if (!ok) simulationEngine.start();
  });
} else {
  simulationEngine.start();
}

// Exposer en dev pour pouvoir régler le tick depuis la console
if (import.meta.env.DEV) {
  (window as unknown as Record<string, unknown>).sim = simulationEngine;
}

// StrictMode désactivé : PixiJS v8 n'est pas compatible avec le double-mount
// de React 18 Strict Mode (bug _cancelResize dans Application.destroy).
// En production il n'y a pas de double-mount, ce n'est qu'un problème de dev.
ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
